import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={128}
    height={128}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#a)'>
      <g filter='url(#b)'>
        <path
          d='M86.032 42.947h7.804v8.496a3.902 3.902 0 1 1-7.804 0v-8.496Z'
          fill='#DA9653'
        />
      </g>
      <g clipPath='url(#c)'>
        <g filter='url(#d)'>
          <path
            d='M4.57 26.05 45.034 2.713a5.084 5.084 0 0 1 6.944 1.864L79.92 53.021 35.053 78.9 4.571 26.05Z'
            fill='url(#e)'
          />
          <path
            d='M4.57 26.05 45.034 2.713a5.084 5.084 0 0 1 6.944 1.864L79.92 53.021 35.053 78.9 4.571 26.05Z'
            fill='url(#f)'
          />
        </g>
        <path
          d='m33.211 81.43 47.344-27.308 3.175 5.505-1.1.635-.467 1.736-45.141 26.038-3.81-6.606Z'
          fill='url(#g)'
        />
        <path
          d='m33.211 81.43 47.344-27.308 3.175 5.505-1.1.635-.467 1.736-45.141 26.038-3.81-6.606Z'
          fill='url(#h)'
        />
        <path
          d='M4.295 26.208a3.813 3.813 0 0 0-1.398 5.208l31.118 53.95 2.202-1.27a2.542 2.542 0 0 1 .932-3.472l2.202-1.27L7.598 24.303l-3.303 1.905Z'
          fill='url(#i)'
        />
        <g filter='url(#j)'>
          <path
            d='M34.778 79.058a3.813 3.813 0 0 0-1.398 5.208l1.27 2.202a3.813 3.813 0 0 0 5.209 1.398l42.736-24.65c1.438-.83 1.98-2.124 1.135-3.59L39.69 85.03a2.542 2.542 0 0 1-2.54-4.404l44.04-25.403-1.27-2.202-45.142 26.038Z'
            fill='url(#k)'
          />
        </g>
      </g>
      <g clipPath='url(#l)'>
        <g filter='url(#m)'>
          <path
            d='M123.819 32.635 86.069 11.27a4.721 4.721 0 0 0-6.433 1.784L54.058 58.25l41.858 23.69 27.903-49.306Z'
            fill='url(#n)'
          />
          <path
            d='M123.819 32.635 86.069 11.27a4.721 4.721 0 0 0-6.433 1.784L54.058 58.25l41.858 23.69 27.903-49.306Z'
            fill='url(#o)'
          />
        </g>
        <path
          d='m97.646 84.275-44.17-24.997-2.906 5.137 1.027.58.446 1.61 42.115 23.834 3.488-6.164Z'
          fill='url(#p)'
        />
        <path
          d='m97.646 84.275-44.17-24.997-2.906 5.137 1.027.58.446 1.61 42.115 23.834 3.488-6.164Z'
          fill='url(#q)'
        />
        <path
          d='M124.076 32.781a3.541 3.541 0 0 1 1.338 4.826L96.929 87.94l-2.055-1.163a2.36 2.36 0 0 0-.891-3.217l-2.055-1.163 29.067-51.36 3.081 1.744Z'
          fill='url(#r)'
        />
        <g filter='url(#s)'>
          <path
            d='M96.173 82.086a3.541 3.541 0 0 1 1.337 4.826l-1.163 2.054a3.54 3.54 0 0 1-4.825 1.338L51.651 67.739c-1.342-.759-1.855-1.957-1.081-3.324l41.087 23.253a2.36 2.36 0 0 0 2.326-4.109L52.895 60.306l1.162-2.054 42.116 23.834Z'
            fill='url(#t)'
          />
        </g>
      </g>
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='#4CC88C'
        fillOpacity={0.55}
      />
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='#4CC88C'
        fillOpacity={0.55}
      />
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='#4CC88C'
        fillOpacity={0.55}
      />
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='url(#u)'
      />
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='url(#v)'
      />
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='url(#w)'
      />
      <path
        d='M31.356 118.053 13.925 64.019h103.92l-17.626 54.063a10.032 10.032 0 0 1-9.53 6.94H40.896c-4.347 0-8.2-2.814-9.54-6.969Z'
        fill='url(#x)'
      />
      <g filter='url(#y)'>
        <path
          d='M93.701 124.558a10.026 10.026 0 0 0 3.32-1.799l-58.823-58.74h-3.082l-1.014 1.026 59.599 59.513Z'
          fill='url(#z)'
        />
      </g>
      <g filter='url(#A)'>
        <path
          d='M83.45 125.023h-5.122L19.94 66.72l2.545-2.573 60.964 60.876Z'
          fill='url(#B)'
        />
      </g>
      <g filter='url(#C)'>
        <path
          d='M67.612 125.021H62.49L19.877 82.469l-2.434-7.545 50.169 50.097Z'
          fill='url(#D)'
        />
      </g>
      <g filter='url(#E)'>
        <path
          d='M51.773 125.017h-5.122l-19.247-19.22-2.434-7.545 26.803 26.765Z'
          fill='#8E6144'
        />
      </g>
      <g filter='url(#F)'>
        <path
          d='m101.026 115.606 1.258-3.858-47.796-47.729h-5.122l51.66 51.587Z'
          fill='url(#G)'
        />
      </g>
      <g filter='url(#H)'>
        <path
          d='m64.135 64.02-37.977 37.922-1.248-3.868 34.103-34.055h5.122Z'
          fill='#8E6243'
        />
        <path
          d='m64.135 64.02-37.977 37.922-1.248-3.868 34.103-34.055h5.122Z'
          fill='#946340'
        />
      </g>
      <g filter='url(#I)'>
        <path
          d='m105.027 103.334 1.258-3.858-35.507-35.457h-5.122l39.371 39.315Z'
          fill='url(#J)'
        />
      </g>
      <g filter='url(#K)'>
        <path
          d='M47.845 64.02 22.19 89.637l-1.248-3.868 21.781-21.75h5.122Z'
          fill='#8E6243'
        />
        <path
          d='M47.845 64.02 22.19 89.637l-1.248-3.868 21.781-21.75h5.122Z'
          fill='url(#L)'
        />
      </g>
      <g filter='url(#M)'>
        <path
          d='m109.028 91.063 1.258-3.859L87.068 64.02h-5.122l27.082 27.043Z'
          fill='url(#N)'
        />
      </g>
      <g filter='url(#O)'>
        <path
          d='M31.555 64.02 18.22 77.334l-1.248-3.868 9.46-9.448h5.123Z'
          fill='#8E6243'
        />
        <path
          d='M31.555 64.02 18.22 77.334l-1.248-3.868 9.46-9.448h5.123Z'
          fill='url(#P)'
        />
      </g>
      <g filter='url(#Q)'>
        <path
          d='m113.029 78.79 1.258-3.858-10.928-10.913h-5.122l14.792 14.772Z'
          fill='url(#R)'
        />
      </g>
      <g filter='url(#S)'>
        <path
          d='m94.675 64.02 1.014 1.025L36.6 124.05a10.059 10.059 0 0 1-2.965-2.155l57.96-57.877h3.081Z'
          fill='url(#T)'
        />
        <path
          d='m94.675 64.02 1.014 1.025L36.6 124.05a10.059 10.059 0 0 1-2.965-2.155l57.96-57.877h3.081Z'
          fill='url(#U)'
        />
      </g>
      <g filter='url(#V)'>
        <path
          d='M51.464 125.023h-5.122l60.964-60.876 2.545 2.573-58.387 58.303Z'
          fill='url(#W)'
        />
        <path
          d='M51.464 125.023h-5.122l60.964-60.876 2.545 2.573-58.387 58.303Z'
          fill='url(#X)'
        />
      </g>
      <g filter='url(#Y)'>
        <path
          d='M67.302 125.017H62.18l53.046-52.97-2.472 7.583-45.452 45.387Z'
          fill='url(#Z)'
        />
      </g>
      <g filter='url(#aa)'>
        <path
          d='M83.14 125.014H78.02l29.563-29.52-2.473 7.584-21.968 21.936Z'
          fill='url(#ab)'
        />
      </g>
      <g filter='url(#ac)'>
        <path
          d='m80.426 64.02-50.298 50.225-1.248-3.868 46.424-46.358h5.122Z'
          fill='url(#ad)'
        />
        <path
          d='m80.426 64.02-50.298 50.225-1.248-3.868 46.424-46.358h5.122Z'
          fill='url(#ae)'
        />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m26.957 68.61 4.598-4.59h-5.122l-2.037 2.033-1.91-1.908-2.545 2.574 1.894 1.892-4.863 4.855 2.905 9.005 2.184 2.18-1.12 1.119 1.248 3.868 2.433-2.429 5.584 5.576-5.296 5.288 2.494 7.73 3.028 3.024-1.552 1.55 1.248 3.868 2.865-2.861 5.584 5.576-4.942 4.936a10.059 10.059 0 0 0 2.964 2.155l4.54-4.533 5.357 5.35-.154.154h5.43l-.154-.154 5.358-5.351 5.359 5.351-.155.154h5.431l-.154-.154 5.358-5.351 5.358 5.351-.155.154h5.432l-.155-.154 5.358-5.351 5.048 5.041a10.027 10.027 0 0 0 3.32-1.799l-5.807-5.799 5.584-5.576 4.228 4.222 1.258-3.858-2.925-2.921 5.584-5.577.085.084 2.553-7.832-2.638 2.634-5.358-5.35 5.584-5.577 3.859 3.853 1.258-3.858-2.556-2.552 5.024-5.017 2.472-7.583-1.911 1.91-5.359-5.352 1.895-1.891-2.545-2.574-1.911 1.908-2.036-2.034h-5.122l4.598 4.591-5.585 5.577-5.358-5.35 3.797-3.792-1.013-1.026h-3.082l-2.263 2.26-2.262-2.26h-5.122l4.823 4.817-5.584 5.576-5.584-5.576 4.823-4.817h-5.121l-2.263 2.26-2.263-2.26h-5.122l4.824 4.817-5.584 5.577-5.585-5.577 4.824-4.817h-5.122l-2.263 2.26-2.263-2.26h-5.121l4.823 4.817-5.584 5.576-5.584-5.576 4.824-4.817h-5.122l-2.263 2.26-2.262-2.26h-3.082l-1.014 1.026 3.797 3.791-5.358 5.35-5.584-5.575Zm35.378 8.36-5.585-5.576-5.584 5.576 5.585 5.576 5.584-5.576Zm-3.023 8.133 5.584-5.576 5.584 5.576-5.584 5.577-5.584-5.577Zm-5.122 0-5.585-5.576-5.358 5.35 5.584 5.577 5.359-5.35Zm-2.797 7.908 5.358-5.35 5.584 5.576-5.358 5.35-5.584-5.576Zm-5.122 0-5.585-5.576-5.358 5.35 5.584 5.577 5.359-5.351Zm-2.798 7.908 5.358-5.35 5.585 5.576-5.358 5.35-5.585-5.576Zm-5.122 0-5.584-5.576-5.358 5.35 5.584 5.576 5.358-5.35Zm-2.797 7.908 5.358-5.351 5.585 5.576-5.359 5.351-5.584-5.576ZM67.457 76.97l5.584-5.576 5.584 5.576-5.584 5.576-5.584-5.576Zm18.635 39.99-5.358 5.351-5.358-5.351 5.358-5.35 5.358 5.35Zm8.145-8.133-5.584 5.576-5.358-5.351 5.584-5.576 5.358 5.351Zm8.146-8.134-5.585 5.577-5.358-5.351 5.584-5.576 5.359 5.35Zm8.371-24.175-5.359-5.35-5.584 5.576 5.358 5.35 5.585-5.576Zm-8.145 8.134-5.359-5.35-5.584 5.575 5.358 5.351 5.585-5.576Zm-8.146 8.133-5.358-5.35-5.584 5.576 5.358 5.35 5.584-5.576Zm-8.145 8.134-5.358-5.35-5.584 5.576 5.358 5.35 5.584-5.576Zm-8.145 8.133-5.358-5.35-5.358 5.35 5.358 5.351 5.358-5.351Zm-7.92 7.908-5.357-5.35-5.358 5.35 5.358 5.351 5.358-5.351Zm-15.837 0-5.359 5.351-5.358-5.351 5.358-5.35 5.359 5.35Zm7.919-7.908-5.358 5.351-5.358-5.351 5.358-5.35 5.358 5.35Zm7.919-7.907-5.358 5.35-5.358-5.35 5.358-5.35 5.358 5.35Zm8.145-8.134-5.584 5.576-5.358-5.35 5.584-5.576 5.358 5.35Zm8.145-8.133-5.584 5.576-5.358-5.35 5.584-5.577 5.358 5.35Zm8.145-8.134-5.584 5.576-5.358-5.35 5.584-5.576 5.358 5.35Zm-70.293-5.576-5.358 5.35 5.584 5.576 5.358-5.35-5.584-5.576Zm16.064.225-5.358 5.35 5.584 5.577 5.358-5.35-5.584-5.577Zm-7.919 7.908-5.358 5.35 5.584 5.577 5.358-5.35-5.584-5.577Z'
        fill='url(#af)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m26.957 68.61 4.598-4.59h-5.122l-2.037 2.033-1.91-1.908-2.545 2.574 1.894 1.892-4.863 4.855 2.905 9.005 2.184 2.18-1.12 1.119 1.248 3.868 2.433-2.429 5.584 5.576-5.296 5.288 2.494 7.73 3.028 3.024-1.552 1.55 1.248 3.868 2.865-2.861 5.584 5.576-4.942 4.936a10.059 10.059 0 0 0 2.964 2.155l4.54-4.533 5.357 5.35-.154.154h5.43l-.154-.154 5.358-5.351 5.359 5.351-.155.154h5.431l-.154-.154 5.358-5.351 5.358 5.351-.155.154h5.432l-.155-.154 5.358-5.351 5.048 5.041a10.027 10.027 0 0 0 3.32-1.799l-5.807-5.799 5.584-5.576 4.228 4.222 1.258-3.858-2.925-2.921 5.584-5.577.085.084 2.553-7.832-2.638 2.634-5.358-5.35 5.584-5.577 3.859 3.853 1.258-3.858-2.556-2.552 5.024-5.017 2.472-7.583-1.911 1.91-5.359-5.352 1.895-1.891-2.545-2.574-1.911 1.908-2.036-2.034h-5.122l4.598 4.591-5.585 5.577-5.358-5.35 3.797-3.792-1.013-1.026h-3.082l-2.263 2.26-2.262-2.26h-5.122l4.823 4.817-5.584 5.576-5.584-5.576 4.823-4.817h-5.121l-2.263 2.26-2.263-2.26h-5.122l4.824 4.817-5.584 5.577-5.585-5.577 4.824-4.817h-5.122l-2.263 2.26-2.263-2.26h-5.121l4.823 4.817-5.584 5.576-5.584-5.576 4.824-4.817h-5.122l-2.263 2.26-2.262-2.26h-3.082l-1.014 1.026 3.797 3.791-5.358 5.35-5.584-5.575Zm35.378 8.36-5.585-5.576-5.584 5.576 5.585 5.576 5.584-5.576Zm-3.023 8.133 5.584-5.576 5.584 5.576-5.584 5.577-5.584-5.577Zm-5.122 0-5.585-5.576-5.358 5.35 5.584 5.577 5.359-5.35Zm-2.797 7.908 5.358-5.35 5.584 5.576-5.358 5.35-5.584-5.576Zm-5.122 0-5.585-5.576-5.358 5.35 5.584 5.577 5.359-5.351Zm-2.798 7.908 5.358-5.35 5.585 5.576-5.358 5.35-5.585-5.576Zm-5.122 0-5.584-5.576-5.358 5.35 5.584 5.576 5.358-5.35Zm-2.797 7.908 5.358-5.351 5.585 5.576-5.359 5.351-5.584-5.576ZM67.457 76.97l5.584-5.576 5.584 5.576-5.584 5.576-5.584-5.576Zm18.635 39.99-5.358 5.351-5.358-5.351 5.358-5.35 5.358 5.35Zm8.145-8.133-5.584 5.576-5.358-5.351 5.584-5.576 5.358 5.351Zm8.146-8.134-5.585 5.577-5.358-5.351 5.584-5.576 5.359 5.35Zm8.371-24.175-5.359-5.35-5.584 5.576 5.358 5.35 5.585-5.576Zm-8.145 8.134-5.359-5.35-5.584 5.575 5.358 5.351 5.585-5.576Zm-8.146 8.133-5.358-5.35-5.584 5.576 5.358 5.35 5.584-5.576Zm-8.145 8.134-5.358-5.35-5.584 5.576 5.358 5.35 5.584-5.576Zm-8.145 8.133-5.358-5.35-5.358 5.35 5.358 5.351 5.358-5.351Zm-7.92 7.908-5.357-5.35-5.358 5.35 5.358 5.351 5.358-5.351Zm-15.837 0-5.359 5.351-5.358-5.351 5.358-5.35 5.359 5.35Zm7.919-7.908-5.358 5.351-5.358-5.351 5.358-5.35 5.358 5.35Zm7.919-7.907-5.358 5.35-5.358-5.35 5.358-5.35 5.358 5.35Zm8.145-8.134-5.584 5.576-5.358-5.35 5.584-5.576 5.358 5.35Zm8.145-8.133-5.584 5.576-5.358-5.35 5.584-5.577 5.358 5.35Zm8.145-8.134-5.584 5.576-5.358-5.35 5.584-5.576 5.358 5.35Zm-70.293-5.576-5.358 5.35 5.584 5.576 5.358-5.35-5.584-5.576Zm16.064.225-5.358 5.35 5.584 5.577 5.358-5.35-5.584-5.577Zm-7.919 7.908-5.358 5.35 5.584 5.577 5.358-5.35-5.584-5.577Z'
        fill='url(#ag)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#ah)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#ai)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#aj)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#ak)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#al)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#am)'
      />
      <rect
        x={9.968}
        y={52.094}
        width={111.939}
        height={16.166}
        rx={3.6}
        fill='url(#an)'
      />
    </g>
    <defs>
      <linearGradient
        id='e'
        x1={28.518}
        y1={12.238}
        x2={59.001}
        y2={65.087}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A6E051' />
        <stop offset={1} stopColor='#74D891' />
      </linearGradient>
      <linearGradient
        id='f'
        x1={54.266}
        y1={7.75}
        x2={50.288}
        y2={10.87}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.014} stopColor='#C0FA7C' />
        <stop offset={1} stopColor='#B0ED5B' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='g'
        x1={38.334}
        y1={84.096}
        x2={82.589}
        y2={58.57}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D5BCEB' />
        <stop offset={1} stopColor='#DCCCED' />
        <stop offset={1} stopColor='#E3D3F2' />
      </linearGradient>
      <linearGradient
        id='h'
        x1={57.185}
        y1={68.3}
        x2={58.988}
        y2={71.426}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9F84AE' />
        <stop offset={1} stopColor='#C5B1D6' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='i'
        x1={20.163}
        y1={60.305}
        x2={25.369}
        y2={57.339}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#63B33B' />
        <stop offset={1} stopColor='#429B5B' />
      </linearGradient>
      <linearGradient
        id='k'
        x1={38.391}
        y1={85.672}
        x2={83.644}
        y2={59.476}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2E7671' />
        <stop offset={1} stopColor='#2E7172' />
      </linearGradient>
      <linearGradient
        id='n'
        x1={101.478}
        y1={19.991}
        x2={73.574}
        y2={69.296}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E6752E' />
        <stop offset={1} stopColor='#E34F2F' />
      </linearGradient>
      <linearGradient
        id='o'
        x1={77.534}
        y1={16.019}
        x2={81.252}
        y2={18.886}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.014} stopColor='#FF9865' />
        <stop offset={1} stopColor='#F68345' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='p'
        x1={92.909}
        y1={86.79}
        x2={51.621}
        y2={63.424}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D5BCEB' />
        <stop offset={1} stopColor='#DCCCED' />
        <stop offset={1} stopColor='#E3D3F2' />
      </linearGradient>
      <linearGradient
        id='q'
        x1={75.284}
        y1={72.266}
        x2={73.634}
        y2={75.182}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9F84AE' />
        <stop offset={1} stopColor='#C5B1D6' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='r'
        x1={109.601}
        y1={64.564}
        x2={104.744}
        y2={61.848}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#BE2C53' />
        <stop offset={1} stopColor='#C02D56' />
      </linearGradient>
      <linearGradient
        id='t'
        x1={92.868}
        y1={88.255}
        x2={50.649}
        y2={64.275}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A71A59' />
        <stop offset={1} stopColor='#A51B5A' />
      </linearGradient>
      <linearGradient
        id='v'
        x1={17.682}
        y1={86.018}
        x2={81.375}
        y2={94.44}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.213} stopColor='#B0845B' />
        <stop offset={1} stopColor='#B0845B' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='w'
        x1={74.094}
        y1={125.022}
        x2={74.094}
        y2={116.881}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AF7C6D' />
        <stop offset={1} stopColor='#CC9467' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='x'
        x1={65.885}
        y1={64.019}
        x2={65.885}
        y2={72.288}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B58253' />
        <stop offset={1} stopColor='#B58253' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='z'
        x1={47.924}
        y1={74.532}
        x2={97.787}
        y2={125.336}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9A633E' />
        <stop offset={1} stopColor='#CD8D55' />
      </linearGradient>
      <linearGradient
        id='B'
        x1={33.892}
        y1={74.718}
        x2={84.03}
        y2={125.994}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#91603F' />
        <stop offset={1} stopColor='#B97C4D' />
      </linearGradient>
      <linearGradient
        id='D'
        x1={28.463}
        y1={83.623}
        x2={67.796}
        y2={121.601}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8C6142' />
        <stop offset={1} stopColor='#A56C46' />
      </linearGradient>
      <linearGradient
        id='G'
        x1={60.99}
        y1={72.978}
        x2={103.487}
        y2={115.714}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9A633E' />
        <stop offset={1} stopColor='#CD8D55' />
      </linearGradient>
      <linearGradient
        id='J'
        x1={74.581}
        y1={70.847}
        x2={106.966}
        y2={103.656}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B97B4C' />
        <stop offset={1} stopColor='#D59458' />
      </linearGradient>
      <linearGradient
        id='L'
        x1={21.945}
        y1={83.625}
        x2={23.519}
        y2={85.003}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9A8070' />
        <stop offset={1} stopColor='#9A8070' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='N'
        x1={88.171}
        y1={68.716}
        x2={110.442}
        y2={91.594}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B97B4C' />
        <stop offset={1} stopColor='#D59458' />
      </linearGradient>
      <linearGradient
        id='P'
        x1={16.178}
        y1={73.359}
        x2={17.949}
        y2={74.621}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.156} stopColor='#9A8070' />
        <stop offset={1} stopColor='#9A8070' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='R'
        x1={101.763}
        y1={66.585}
        x2={113.907}
        y2={79.521}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B97B4C' />
        <stop offset={1} stopColor='#D59458' />
      </linearGradient>
      <linearGradient
        id='T'
        x1={41.735}
        y1={114.102}
        x2={90.32}
        y2={69.496}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#976441' />
        <stop offset={1} stopColor='#B4784C' />
        <stop offset={1} stopColor='#C18352' />
      </linearGradient>
      <linearGradient
        id='U'
        x1={43.13}
        y1={108.063}
        x2={46.173}
        y2={109.996}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#947562' />
        <stop offset={1} stopColor='#947562' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='W'
        x1={47.518}
        y1={126.455}
        x2={103.806}
        y2={69.17}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A46B46' />
        <stop offset={1} stopColor='#CE8E56' />
      </linearGradient>
      <linearGradient
        id='X'
        x1={56.06}
        y1={108.81}
        x2={59.158}
        y2={110.797}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#947562' />
        <stop offset={1} stopColor='#947562' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='Z'
        x1={63.162}
        y1={126.263}
        x2={112.134}
        y2={78.421}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B6794D' />
        <stop offset={1} stopColor='#D4955B' />
      </linearGradient>
      <linearGradient
        id='ab'
        x1={78.566}
        y1={125.709}
        x2={105.858}
        y2={99.046}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B6794D' />
        <stop offset={1} stopColor='#D4955B' />
      </linearGradient>
      <linearGradient
        id='ad'
        x1={35.609}
        y1={105.921}
        x2={79.561}
        y2={64.233}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9A6640' />
        <stop offset={1} stopColor='#B4784C' />
      </linearGradient>
      <linearGradient
        id='ae'
        x1={36.277}
        y1={99.856}
        x2={39.313}
        y2={102.465}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#947562' />
        <stop offset={1} stopColor='#947562' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='af'
        x1={134.969}
        y1={91.98}
        x2={66.006}
        y2={64.252}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D4945A' />
        <stop offset={1} stopColor='#D4945A' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='ag'
        x1={63.765}
        y1={137.076}
        x2={63.765}
        y2={114.654}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.27} stopColor='#8E5A50' />
        <stop offset={1} stopColor='#8E5A50' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='ah'
        x1={100.67}
        y1={52.094}
        x2={48.774}
        y2={103.153}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FBC584' />
        <stop offset={1} stopColor='#C38E57' />
      </linearGradient>
      <linearGradient
        id='aj'
        x1={123.987}
        y1={63.347}
        x2={114.459}
        y2={63.596}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.089} stopColor='#F9C385' />
        <stop offset={1} stopColor='#F9C385' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='ak'
        x1={84.373}
        y1={68.26}
        x2={84.373}
        y2={64.732}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C6854E' />
        <stop offset={1} stopColor='#C6854E' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='an'
        x1={13.044}
        y1={69.645}
        x2={18.859}
        y2={55.556}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A07965' />
        <stop offset={1} stopColor='#CC975F' stopOpacity={0} />
      </linearGradient>
      <filter
        id='b'
        x={84.032}
        y={40.947}
        width={11.805}
        height={16.398}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur
          stdDeviation={1}
          result='effect1_foregroundBlur_316_6901'
        />
      </filter>
      <filter
        id='d'
        x={4.571}
        y={2.031}
        width={75.349}
        height={76.969}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy={0.1} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.623529 0 0 0 0 0.858824 0 0 0 0 0.290196 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='j'
        x={32.87}
        y={53.02}
        width={51.262}
        height={35.457}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy={0.1} />
        <feGaussianBlur stdDeviation={0.15} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.113725 0 0 0 0 0.435294 0 0 0 0 0.439216 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='m'
        x={54.058}
        y={10.658}
        width={69.762}
        height={71.506}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy={0.225} />
        <feGaussianBlur stdDeviation={0.563} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.839216 0 0 0 0 0.384314 0 0 0 0 0.0745098 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='s'
        x={50.207}
        y={58.252}
        width={47.763}
        height={32.737}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy={0.225} />
        <feGaussianBlur stdDeviation={0.338} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.635294 0 0 0 0 0 0 0 0 0 0.337255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='y'
        x={33.502}
        y={64.019}
        width={63.519}
        height={60.539}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='A'
        x={19.341}
        y={64.147}
        width={64.109}
        height={60.877}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='C'
        x={16.843}
        y={74.924}
        width={51.368}
        height={50.096}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.529412 0 0 0 0 0.337255 0 0 0 0 0.235294 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend
          in2='effect1_innerShadow_316_6901'
          result='effect2_innerShadow_316_6901'
        />
      </filter>
      <filter
        id='E'
        x={24.97}
        y={98.252}
        width={27.403}
        height={26.766}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.529412 0 0 0 0 0.337255 0 0 0 0 0.235294 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='F'
        x={48.766}
        y={64.019}
        width={53.519}
        height={51.586}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='H'
        x={24.31}
        y={63.419}
        width={39.825}
        height={38.522}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} dy={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.529412 0 0 0 0 0.337255 0 0 0 0 0.235294 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='I'
        x={65.056}
        y={64.019}
        width={41.229}
        height={39.315}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='K'
        x={20.342}
        y={63.419}
        width={27.504}
        height={26.219}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} dy={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.529412 0 0 0 0 0.337255 0 0 0 0 0.235294 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='M'
        x={81.346}
        y={64.019}
        width={28.94}
        height={27.043}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='O'
        x={16.372}
        y={63.419}
        width={15.182}
        height={13.915}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} dy={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.529412 0 0 0 0 0.337255 0 0 0 0 0.235294 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='Q'
        x={97.637}
        y={64.019}
        width={16.65}
        height={14.771}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.603922 0 0 0 0 0.458824 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='S'
        x={33.034}
        y={63.419}
        width={62.655}
        height={60.631}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} dy={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.619608 0 0 0 0 0.4 0 0 0 0 0.247059 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='V'
        x={46.342}
        y={64.147}
        width={63.909}
        height={61.277}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={0.4} dy={0.4} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.627451 0 0 0 0 0.407843 0 0 0 0 0.223529 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='Y'
        x={62.18}
        y={72.047}
        width={53.446}
        height={53.371}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={0.4} dy={0.4} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.839216 0 0 0 0 0.564706 0 0 0 0 0.282353 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='aa'
        x={78.019}
        y={95.494}
        width={29.963}
        height={29.919}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={0.4} dy={0.4} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.839216 0 0 0 0 0.564706 0 0 0 0 0.282353 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <filter
        id='ac'
        x={28.28}
        y={63.419}
        width={52.146}
        height={50.827}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx={-0.6} dy={-0.6} />
        <feGaussianBlur stdDeviation={0.4} />
        <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
        <feColorMatrix values='0 0 0 0 0.572549 0 0 0 0 0.364706 0 0 0 0 0.219608 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_316_6901' />
      </filter>
      <radialGradient
        id='u'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='rotate(-130.201 65.182 34.881) scale(41.5616 59.3001)'
      >
        <stop stopColor='#F4B572' />
        <stop offset={1} stopColor='#E8A464' />
      </radialGradient>
      <radialGradient
        id='ai'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(0 21.4147 -26.5761 0 103.929 50.246)'
      >
        <stop stopColor='#FFCD87' />
        <stop offset={1} stopColor='#FFCD87' stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id='al'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(0 7.18022 -70.8712 0 87.507 48.356)'
      >
        <stop offset={0.224} stopColor='#DA9954' />
        <stop offset={1} stopColor='#DA9954' stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id='am'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(0 2.0155 -38.7358 0 100.294 55.159)'
      >
        <stop stopColor='#FFD899' />
        <stop offset={1} stopColor='#FFD899' stopOpacity={0} />
      </radialGradient>
      <clipPath id='a'>
        <path fill='#fff' transform='translate(-8 -14)' d='M0 0h147v147H0z' />
      </clipPath>
      <clipPath id='c'>
        <path
          fill='#fff'
          transform='rotate(-29.976 49.862 38.484)'
          d='M0 0h81.347v81.347H0z'
        />
      </clipPath>
      <clipPath id='l'>
        <path
          fill='#fff'
          transform='scale(-1 1) rotate(-29.507 .327 283.089)'
          d='M0 0h75.538v75.538H0z'
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
